<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm04">
<div class="chapterHead">
<h2 class="chapterNumber"><span class="bold">PROLOGUE</span></h2></div>
<div class="chapterBody">
<p class="chapterDateline"><em class="italic">High in the mountains of Colombia:</em></p>
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords">T<span class="smallCaps">HE FOREST</span></span> was dark.</p>
<p class="para">The only sound was the roar of the waterfall.</p>
<p class="para">The moon had risen, a fat, ivory globe that seemed suspended in the leafy branches of the trees. Its light illuminated the clearing and the jewel-like pool.</p>
<p class="para">Illuminated Mia, standing naked under the frothy liquid veil of the waterfall.</p>
<p class="para">He stood on the edge of the clearing, watching her and searching deep within himself for the discipline by which he’d lived his life, but that was the trouble.</p>
<p class="para">He had no discipline when it came to her.</p>
<p class="para">He’d searched for her, found her, then lost her.</p>
<p class="para">Now, he had her trapped. She was his… Except, she wasn’t. She’d made that clear. She had left him for another man. A man who’d wanted her back even though he said she had betrayed him.</p>
<p class="para"><em class="italic">Then, why would you want her?</em> Matthew had asked, at the beginning.</p>
<p class="para">It was an honest question. He’d understood that the woman would be beautiful—the man had shown him <a id="page08">her photograph—but the world was filled with beautiful women. What made this one so special?</a></p><a id="page08">
<p class="para">The man had looked embarrassed. He’d given a little laugh and said he wanted her back because she was more than beautiful.</p>
<p class="para">She was, he’d said, everything a man could ever hope for.</p>
<p class="para">Matthew felt his body quicken.</p>
<p class="para">It wasn’t true. She wasn’t everything a man could hope for.</p>
<p class="para">She was more.</p>
<p class="para">He knew that now because, for a little while, she had belonged to him. She was Eve, she was Jezebel, she was Lilith reborn. She could be as wild as the summer lightning that streaked the hot sky or as sweetly gentle as spring rain.</p>
<p class="para">Just looking at her was enough to stir a man’s soul.</p>
<p class="para">Her face was oval, her eyes wide-set and dark above an aristocratic nose and a mouth made for sin.</p>
<p class="para">Her hair was long and dark as coffee. It tumbled down her back in a mass of curls that begged for his touch.</p>
<p class="para">She was tall and slender, but her breasts were full and round. His breathing grew uneven at the thought of how they’d filled his hands.</p>
<p class="para">And her legs…her legs were meant to clasp a man’s waist. He could still remember the feel of them as he parted her thighs and sank deep, so deep into her heat.</p>
<p class="para">Matthew shuddered.</p>
<p class="para">God, was he losing his mind?</p>
<p class="para">Who was Mia Palmieri? What was she? Was she his woman or Hamilton’s? Had everything been a game?</p>
<p class="para">All he knew right now was that she was a temptress.</p>
<p class="para">But he was a warrior.</p>
</a><a id="page09">
<p class="para">She swung toward him.</p>
<p class="para">Matthew held his ground. She couldn’t possibly see him. He was still dressed in black, the kind of stuff he’d worn on night maneuvers in Special Forces and then in the Agency. He knew that he blended in against the tangle of night-shadowed forest behind him.</p>
<p class="para">Did she somehow sense his presence?</p>
<p class="para">Was that why she was tilting her head back, lifting her face to the curtain of water? Why she was raising her hands, cupping her breasts as if she were offering herself to the gods?</p>
<p class="para">Offering herself to him?</p>
<p class="para">He was hard as stone. So hard that it hurt.</p>
<p class="para">Once, he had promised to return her to the man who’d sent him to find her.</p>
<p class="para">Tonight, his only promise was to himself.</p>
<p class="para">Slowly he stepped forward into the patch of moonlight that swathed the little clearing. He waited, muscles tensed, willing her to look toward him again. Why? Why not just call out and let her know he was here?</p>
<p class="para">The answer was a cold whisper inside his head.</p>
<p class="para">Because he wanted to see what she did when she saw him. Would she run to him? Throw herself into his arms? If she did—God, if she did…</p>
<p class="para">But she didn’t.</p>
<p class="para">Her reaction was like a kick in the gut.</p>
<p class="para">Her eyes widened. Her lips parted on a little exclamation of surprise. She flung one arm across her breasts, the other over her feminine delta in an age-old gesture of modesty.</p>
<p class="para">He knew damned well it was reflex action and nothing more, knew he had all the answers he needed…the answers he hadn’t wanted.</p>
</a><a id="page10">
<p class="para">“No,” she said.</p>
<p class="para">He couldn’t hear the word but he could see her mouth form it. “No,” she said again, and Matthew felt the swift rush of adrenaline as it coursed through his body.</p>
<p class="para">His lips drew back in a predator’s smile. He toed off his running shoes, pulled his shirt over his head, unzipped his trousers and stepped free of them.</p>
<p class="para">Stood still, letting her see the full measure of his arousal.</p>
<p class="para">Then he dove cleanly into the dark jungle pool and went for her.</p>
</a></div><a id="page10">
</a></div>
<a id="page10">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// captiveinhisbed_fm04.vue?de109f92